import React, { useState } from "react";
import * as RB from "react-bootstrap";
import Swal from "sweetalert2";
import * as utils from "../../Utils/comman";
function MultiFileUpload({ uploadedFiles, setUploadedFiles, EditfileUploads,
  setEditFileUploads }) {
  console.log("EditfileUploads");
  console.log(EditfileUploads);
  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const [isDocDragging, setIsDocDragging] = useState(false);
  const [isValidFile, setIsValidFile] = useState(true);
  const [isEdit, setIsEdit] = useState(false);

  const allowedFileTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDraggingOver(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDraggingOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDraggingOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDraggingOver(false);

    const files = Array.from(e.dataTransfer.files);
    const validFiles = files.filter((file) =>
      allowedFileTypes.includes(file.type)
    );

    if (validFiles.length !== files.length) {
      setIsValidFile(false);
      return;
    } else {
      setIsValidFile(true);
    }

    setUploadedFiles((prevFiles) => [...prevFiles, ...validFiles]);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter((file) =>
      allowedFileTypes.includes(file.type)
    );

    if (validFiles.length !== files.length) {
      setIsValidFile(false);
      return;
    } else {
      setIsValidFile(true);
    }

    setUploadedFiles((prevFiles) => [...prevFiles, ...validFiles]);
  };

  const handleDeleteFile = (index) => {
    const updatedFiles = [...uploadedFiles];
    updatedFiles.splice(index, 1);
    setUploadedFiles(updatedFiles);
  };
  const getFileMimeType = (file) => {
    const fileExtension = file.announce_image.split(".").pop().toLowerCase();
    switch (fileExtension) {
      case "xls":
        return "excel";
      case "doc":
      case "docx":
        return "word";
      case "png":
        return "image";
      case "jpg":
      case "jpeg":
        return "image";
      case "pdf":
        return "pdf";
      default:
        return "file";
    }
  };

  const handleRemoveEditFile = (file, category) => {
    console.log(file);
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedFiles = EditfileUploads?.map((f) =>
          f.id === file.id ? { ...f, isDeleted: true } : f
        );
        console.log("updatedFiles after delete")
        console.log(updatedFiles)
        // setEditFileUploads((prev) => ({
        //   ...prev,
        //   [category]: updatedFiles,
        // }));
        setEditFileUploads(updatedFiles);

        utils
          .callAPI("get", `Announcement/document-delete?id=${file?.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              // getMeetings();
            }
          })
          .catch((err) => { });
      }
    });
  };
  return (
    <RB.Card>
      <RB.Card.Body className="p-2">
        <h6 className="mb-2">Announcement Attachments</h6>
        <hr />
        <div
          className={`border p-4 text-center d-flex flex-column align-items-center ${isDraggingOver ? "bg-info" : ""
            }`}
          onDragOver={handleDragOver}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <div className="avatar avatar-circle avatar-lg bg-light text-dark">
            <i className="material-icons-outlined">cloud_upload</i>
          </div>
          <p className="mb-0">Drag & Drop your files here</p>
          <small className="mb-2">or</small>
          <div>
            <input
              type="file"
              accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx"
              multiple
              style={{ display: "none" }}
              onChange={handleFileChange}
              id="fileInput"
            />
            <RB.Button
              variant="primary"
              className="me-2"
              onClick={() => document.getElementById("fileInput").click()}
            >
              <i className="las la-file-upload me-1"></i>Browse Files
            </RB.Button>
          </div>
        </div>
        {/* {!isValidFile && ( */}
        <span>
          <small>
            *Note: Only JPG, JPEG, PNG, PDF, Word, and Excel files are allowed
          </small>
        </span>
        {/* )} */}

        <RB.Row className="mt-3 g-3">
          {uploadedFiles.map((file, index) => (
            <RB.Col key={index} className="col-md-3 col-lg-3">
              <div className="position-relative me-2 mb-4 rounded border p-3 text-center">
                <div className="product-doc-upload">
                  <a
                    href={URL.createObjectURL(file)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none text-dark"
                  >
                    <i className="material-icons-outlined md-64">
                      {file.type.includes("image")
                        ? "image"
                        : file.type.includes("pdf")
                          ? "picture_as_pdf"
                          : "description"}
                    </i>
                    <div className="text-center">
                      {file.name.slice(0, 10)}...
                    </div>
                  </a>
                </div>
                <RB.Button
                  variant="danger"
                  className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                  onClick={() => handleDeleteFile(index)}
                >
                  <i className="material-icons-outlined">delete</i>
                </RB.Button>
              </div>
            </RB.Col>
          ))}

          {/* Render images from EditfileUploads */}
          {EditfileUploads?.filter((file) => !file.isDeleted)
            .map((file, index) => (
              <RB.Col key={index} className="col-md-3 col-lg-3">
                <div className="position-relative me-2 mb-4 rounded border p-3 text-center">
                  <div className="product-doc-upload">
                    <a
                      href={file.attachPath} // Set the image URL from the server
                      target="_blank" // Open in new tab
                      rel="noopener noreferrer" // For security purposes
                      className="text-decoration-none text-dark"
                    >
                      {/* <i className="material-icons-outlined md-64">
                        {file.type.includes("image")
                          ? "image"
                          : file.type.includes("pdf")
                            ? "picture_as_pdf"
                            : "description"}
                      </i> */}
                      {getFileMimeType(file) === 'image' ? (
                        <i className="material-icons-outlined md-64">image</i>
                      ) : getFileMimeType(file) === 'pdf' ? (
                        <i className="material-icons-outlined md-64">picture_as_pdf</i>
                      ) : (getFileMimeType(file) === 'excel' || getFileMimeType(file) === 'word') ? (
                        <i className="material-icons-outlined md-64">description</i>
                      ) : (
                        <i className="material-icons-outlined md-64">insert_drive_file</i>
                      )}
                      <div className="text-center">
                        {file.announce_image.slice(0, 10)}...
                      </div>
                    </a>
                  </div>
                  <RB.Button
                    variant="danger"
                    className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                    onClick={() =>
                      handleRemoveEditFile(file)
                    }
                  >
                    <i className="material-icons-outlined">delete</i>
                  </RB.Button>
                </div>
              </RB.Col>
            ))}
        </RB.Row>
      </RB.Card.Body>
    </RB.Card>
  );
}

export default MultiFileUpload;
